import useReleases from './useReleases';
import usePaginationState from '../../../generic/Pagination/usePaginationState';
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '../../../generic/Pagination/consts';
import { useDebouncedInputValue } from '../../../../hooks';

/**
 * Hook which composes the useReleases AsyncValue fetcher hook
 * with the usePaginationState. These two combined allow for
 * paginated fetching of releases on the releases page.
 */
const usePaginatedReleases = (releaseGroupId: string) => {
  const { page, count, setPage, setCount } = usePaginationState(DEFAULT_PAGE, DEFAULT_PAGE_SIZE);
  const {
    value: search,
    onChange: onSearchChange,
    debouncedValue: debouncedSearch,
  } = useDebouncedInputValue();
  const releasesQuery = useReleases(releaseGroupId, page, count, debouncedSearch);

  return {
    error: releasesQuery.error,
    isLoading: releasesQuery.isLoading,
    releases: releasesQuery.data?.releases || [],
    total: releasesQuery.data?.total || null,
    page,
    count,
    setPage,
    setCount,
    search,
    onSearchChange,
  };
};

export default usePaginatedReleases;
